export const CLUB_QUERY_KEYS = {
  base: ['clubs'],
  byId: (orgId: number): unknown[] => [...CLUB_QUERY_KEYS.base, orgId],
  filtered: (filters: AnyObject): unknown[] => [...CLUB_QUERY_KEYS.base, filters],
};
